import * as React from 'react';
import './App.css';
import MainMenu from "./components/menu/MainMenu";
import {createTheme, ThemeProvider} from "@mui/material";
import {amber, blue, grey, red, yellow} from "@mui/material/colors";
import {BrowserRouter} from "react-router-dom";
import {DoughRecipePrintWrapper} from "./components/dough/DoughRecipePrintWrapper";
import {LevainRecipePrintWrapper} from "./components/levain/LevainRecipePrintWrapper";
import {PRINT_DOUGH_URI, PRINT_LEVAIN_URI} from "./components/utils/RoutingUtils";
import {formTypeLevain, formTypeWeightDough, formTypeRatioDough} from "./components/shared/Types";
import {useAuth} from "react-oidc-context";
import {useEffect} from "react";
import {renewAccessTokenInterval} from "./components/utils/AuthUtils";
import AppRoutes from "./AppRoutes";

export const fdTheme = createTheme({
  palette: {
    primary: {
      main: amber[500]
    },
    secondary: {
      main: yellow[400]
    },
    attention: {
      main: red[500]
    },
    water: {
      main: blue[300]
    },
    dark: {
      main: grey[800]
    }
  }
})

// this supports un-themed print page rendering...
//   keep this in sync with the actual theme palette!
export const THEME_PRIMARY_COLOR = '#ffc107'

export const urlRatioDough = '/ratio'
export const urlWeightDough = '/weight'
export const urlLevain = '/levain'
export const urlQueryParamConverted = 'converted'
export const formTypeUrlMap = [
  {
    formType: formTypeRatioDough,
    url: urlRatioDough
  },
  {
    formType: formTypeWeightDough,
    url: urlWeightDough
  },
  {
    formType: formTypeLevain,
    url: urlLevain
  }
]

function App(props) {
  const auth = useAuth();
  const [intervalRef, setIntervalRef] = React.useState(undefined);

  useEffect(() => {
    // console.log(`checking auth... isAuthenticated=${auth.isAuthenticated}`);
    if (auth.isAuthenticated && intervalRef === undefined) {
      // console.log(`starting auth refresh interval`)
      let intervalReference = setInterval(() => {
        auth.signinSilent().then(user => {
          // console.info(`App.useEffect.signinSilent got access_token: ${formatToken(user.access_token)}...`)
        });
      }, renewAccessTokenInterval)
      setIntervalRef(intervalReference)
    } else if (intervalRef !== undefined) {
      // console.log(`clearing auth refresh interval`)
      clearInterval(intervalRef)
      setIntervalRef(undefined)
    }
    return () => {
      clearInterval(intervalRef);
      setIntervalRef(undefined)
      // console.log(`App.useEffect stopped refresh interval.`)
    }
  }, [auth.isAuthenticated]);

const currentHref = window.location.href

  // bypass router encapsulated components to single out only the component of interest for printing
  if (currentHref.match(`.*${PRINT_DOUGH_URI}`)) {
    return (
        <div>
          <DoughRecipePrintWrapper/>
        </div>
    )
  } else if (currentHref.match(`.*${PRINT_LEVAIN_URI}`)) {
    return (
        <div>
          <LevainRecipePrintWrapper/>
        </div>
    )
  }

  return (
      <ThemeProvider theme={fdTheme}>
        <div className="App">
          <header className="App-content">
            <BrowserRouter>
              <MainMenu/>
              <AppRoutes/>
            </BrowserRouter>
          </header>
        </div>
      </ThemeProvider>
  );
}

export default App;
